import h from 'snabbdom/h';
import { map } from 'ramda';
import styles from './styles';
import { getErrors } from '../modules/sceneIO';

export default function error(store) {
  return h('div', { key: 'error', style: styles.absoluteMaxCentered }, [
    h('div', { style: { flex: '0 0 100%' } }, getErrors(store).map((err) => {
      return h('h2', err);
    }).toArray()),
  ]);
};



// WEBPACK FOOTER //
// ./src/components/error.js